import { useAppSelector } from '../..'
import type { IDistributionPlan } from '../../../models/DistributionPlan'
import type { IDistributionSeries } from '../../../models/DistributionSeries'

export const getAllSeriesData = (): IDistributionSeries[] => useAppSelector((state) => state.distributionSeries?.distributionSeries ?? [])
export const getSeriesSlotsList = (): Record<string, IDistributionPlan> => useAppSelector((state) => state.distributionSeries?.distributionPlans ?? {})
export const getDistributionSeriesLoading = (): boolean => useAppSelector((state) => state.distributionSeries?.distributionSeriesLoading ?? false)
export const getDistributionPlanLoading = (): Record<string, boolean> => useAppSelector((state) => state.distributionSeries?.distributionPlansLoading ?? {})
